/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UploadsControllerSignQueryResponse } from "../../models/uploadsController/UploadsControllerSign";

function getUploadsControllerSignUrl() {
  const res = { method: 'GET', url: `/api/v1/uploads/signature` as const }  
  return res
}

/**
 * @summary Generate Transloadit signature for Uppy assemblies
 * {@link /api/v1/uploads/signature}
 */
export async function uploadsControllerSign(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UploadsControllerSignQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getUploadsControllerSignUrl().url.toString(), ... requestConfig })  
  return res.data
}